import React, { FC } from 'react'
import styles from "../../assets/styles/appointments.module.css";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";
interface PropsTypes {
    chartData: PieDataTypes[] | [];
    title?: string;
}
const CustomPieChart: FC<PropsTypes> = ({ chartData, title }) => {
    const renderLabel = (entry: { name: string; value: number }) => {
        return `${entry.name} (${entry.value})`;
    };
    return (
        <div className='bg-white shadow-lg rounded-lg p-4'>
            {
                title &&
                <div className={styles.chartHeadAndBtn}>
                    <h3>{title}</h3>
                </div>
            }
            <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                    <Pie
                        data={chartData}
                        label={renderLabel}
                        outerRadius={100}
                        fill="#0562cc"
                        dataKey="value"
                        className="PieChartStyle"
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </div>
    )
}

export default CustomPieChart